import ReportNSByAverageCarAge from "~/pages/SRR/Tables/ReportNSByAverageCarAge";
import ReportNSByAverageCarAgeItog from "~/pages/SRR/Tables/ReportNSByAverageCarAgeItog";
import ReportNSByClient from "~/pages/SRR/Tables/ReportNSByClient";
import ReportNSByClientCarSale from "~/pages/SRR/Tables/ReportNSByClientCarSale";
import ReportNSByConsultant from "~/pages/SRR/Tables/ReportNSByConsultant";
import ReportNSByDealer from "~/pages/SRR/Tables/ReportNSByDealer";
import ReportNSByOldClients from "~/pages/SRR/Tables/ReportNSByOldClients";
import ReportNSByWarmClients from "~/pages/SRR/Tables/ReportNSByWarmClients";
import ReportReturnCarServiceByDealer from "~/pages/SRR/Tables/ReportReturnCarServiceByDealer";
import ReportReturnLoyaltyServiceByDealerTable from "~/pages/SRR/Tables/ReportReturnLoyaltyServiceByDealerTable";
import ReportReturnSRR3ByCar from "~/pages/SRR/Tables/ReportReturnSRR3ByCar";
import ReportReturnSRR3ByDealer from "~/pages/SRR/Tables/ReportReturnSRR3ByDealer";
import ReportReturnSRR3ForPayments from "~/pages/SRR/Tables/ReportReturnSRR3ForPayments";
import ReportReturnSRR5ByDealer from "~/pages/SRR/Tables/ReportReturnSRR5ByDealer";
import ReportReturnUniqueServiceTable from "~/pages/SRR/Tables/ReportReturnUniqueServiceTable";
import TOFriendOrFoeByPeriodByCarFamily from "~/pages/SRR/Tables/TOFriendOrFoeByPeriodByCarFamily";
import TOFriendOrFoeBySalesPeriod from "~/pages/SRR/Tables/TOFriendOrFoeBySalesPeriod";
import TOMonthOfControlCarFamilyRegion from "~/pages/SRR/Tables/TOMonthOfControlCarFamilyRegion";
import TOMonthOfControlFriendOrFoe from "~/pages/SRR/Tables/TOMonthOfControlFriendOrFoe";
import TOMonthOfControlFriendOrFoeByCarFamily from "~/pages/SRR/Tables/TOMonthOfControlFriendOrFoeByCarFamily";
import TOMonthOfControlMine from "~/pages/SRR/Tables/TOMonthOfControlMine";
import TOOwnBySalesPeriod from "~/pages/SRR/Tables/TOOwnBySalesPeriod";
import TOReturnCarForServiceByPeriodConsolidated from "~/pages/SRR/Tables/TOReturnCarForServiceByPeriodConsolidated";
import warrantyRepairBySalesPeriod from "~/pages/SRR/Tables/warrantyRepairBySalesPeriod";
import warrantyRepairMonthOfControl from "~/pages/SRR/Tables/warrantyRepairMonthOfControl";

const dealerArr = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];
const cityArr = ["city", "subject", "FO"];
const foArr = ["FO"];
const regionArr = ["subject", "FO"];
const countryArr = [];

interface ICustomAdditionFields {
  dealerFields?: string[];
  cityFields?: string[];
  foFields?: string[];
  regionFields?: string[];
  countryFields?: string[];
}

export function groupProverka(
  groupChecker,
  additionFields?: ICustomAdditionFields,
) {
  let optionsTable = [];
  switch (groupChecker["group"]) {
    case "dealer":
      optionsTable = [...dealerArr, ...(additionFields?.dealerFields || [])];
      break;
    case "city":
      optionsTable = [...cityArr, ...(additionFields?.cityFields || [])];
      break;
    case "fo":
      optionsTable = [...foArr, ...(additionFields?.foFields || [])];
      break;
    case "region":
      optionsTable = [...regionArr, ...(additionFields?.regionFields || [])];
      break;
    case "country":
      optionsTable = [...countryArr, ...(additionFields?.countryFields || [])];
      break;
  }
  return optionsTable;
}

export const customHeaderForUVIN = (valueReport, tableRows, t) => {
  if (
    valueReport === "ReportReturnLoyaltyServiceByDealer" &&
    tableRows.length > 0
  ) {
    const periods = tableRows[0]?.periods?.map((el) => el.period) || [];
    periods.push(`${periods[0]} - ${periods[periods.length - 1]}`);

    const secondRowCellsForGenerate = [
      t("srr.Loyalty5Year"),
      t("srr.commonLoyalty"),
    ];
    const thirdRowcellsForGenerate = [
      t("srr.soldAutoBy5Years"),
      t("srr.UniqueCallsBy5Years"),
      t("srr.commonLoyalty"),
      t("srr.SoldCountBy10Years"),
      t("srr.UniqueCallsBy10Years"),
      t("srr.commonLoyalty"),
    ];
    const thirdRow = [
      t("srr.DealerName"),
      t("srr.city"),
      t("srr.INN"),
      t("srr.uniqueCode"),
      t("srr.subject1"),
      t("srr.fo"),
      t("srr.activeDealers"),
    ];
    const secondRow = [
      ...[...Array(thirdRow.length).fill("")],
      ...periods
        .map(() => [
          {
            name: secondRowCellsForGenerate[0],
            colSpan: 3,
          },
          {
            name: secondRowCellsForGenerate[1],
            colSpan: 3,
          },
        ])
        .flat(),
    ];
    const firstRow = [
      ...[...Array(thirdRow.length).fill("")],
      ...periods.map((el) => ({
        name: el,
        colSpan: thirdRowcellsForGenerate.length,
      })),
    ];

    return [
      firstRow,
      secondRow,
      [
        ...thirdRow,
        ...periods.map((el) => thirdRowcellsForGenerate.map((el) => el)).flat(),
      ],
    ];
  }
  return null;
};

const makeCustomHeaderNS =
  (keys: string[], thirdRowKeys: string[]) =>
  (valueReport, tableRows, t, bonus?) => {
    if (keys.includes(valueReport) && tableRows.length > 0) {
      const periods = tableRows[0].periodsData.map((el) => el.periodStr);
      periods.push(`${periods[0]} - ${periods[periods.length - 1]}`);

      const secondRowCellsForGenerate = [
        t("srr.2АМ"),
        t("srr.3АМ"),
        t("srr.4АМ"),
      ];
      const thirdRowcellsForGenerate = [
        t("srr.soldCars"),
        t("srr.soldCarsToNewClients"),
        t("srr.percentNewClients"),
        t("srr.soldCarsToLoyalClients"),
        t("srr.soldCarsToLoyalClientsMoney"),
        t("srr.percentLoyalClients"),
        t("srr.twoCars"),
        t("srr.percentTwoCars"),
        t("srr.threeCars"),
        t("srr.percentThreeCars"),
        t("srr.fourOrMoreCars"),
        t("srr.percentFourOrMoreCars"),
      ];
      const thirdRow = thirdRowKeys.map((el) => t(`srr.${el}`));
      const arrBonus = [];

      const secondRow = [
        ...[...Array(thirdRow.length).fill("")],
        ...periods
          .map(() => [
            {
              name: "",
              colSpan: 6,
            },
            {
              name: secondRowCellsForGenerate[0],
              colSpan: 2,
            },
            {
              name: secondRowCellsForGenerate[1],
              colSpan: 2,
            },
            {
              name: secondRowCellsForGenerate[2],
              colSpan: 2,
            },
          ])
          .flat(),
      ];

      const firstRow = [
        ...[...Array(thirdRow.length).fill("")],
        ...periods.map((el) => ({
          name: el,
          colSpan: thirdRowcellsForGenerate.length,
        })),
      ];

      if (bonus) {
        firstRow.push({
          name: "",
          colSpan: 3,
        });
        secondRow.push(
          {
            name: t("srr.DataBonus"),
            colSpan: 2,
          },
          {
            name: "",
            colSpan: 1,
          },
        );
        arrBonus.push(
          {
            name: t("srr.bonusCarCount"),
            colSpan: 1,
          },
          {
            name: t("srr.bonusCarMoney"),
            colSpan: 1,
          },
          {
            name: t("srr.coefficientAward"),
            colSpan: 1,
          },
        );
      }

      return [
        firstRow,
        secondRow,
        [
          ...thirdRow,
          ...periods
            .map((el) => thirdRowcellsForGenerate.map((el) => el))
            .flat(),
          ...arrBonus,
        ],
      ];
    }
    return null;
  };

export const customHeaderForNS = makeCustomHeaderNS(
  ["ReportNSByDealer", "ReportNSByConsultant"],
  [
    "DealerName",
    "city",
    "INN",
    "uniqueCode",
    "subject1",
    "fo",
    "activeDealers",
  ],
);

const customHeaderConsultantBase = makeCustomHeaderNS(
  ["ReportNSByConsultant"],
  ["DealerName", "consultant"],
);

export const customHeaderConsultant = (valueReport, tableRows, t) =>
  customHeaderConsultantBase(valueReport, tableRows, t);

export const customHeaderByClient = (valueReport, tableRows, t) => {
  if (valueReport === "ReportNSByClient" && tableRows.length > 0) {
    let maxNum = 0;
    let indexTable = 0;
    for (let i = 0; i < tableRows.length; i++) {
      if (tableRows[i]["soldCars"].length > maxNum) {
        maxNum = tableRows[i]["soldCars"].length;
        indexTable = i;
      }
    }

    const secondRowCellsForGenerate = [t("srr.goldenId")];
    const thirdRowcellsForGenerate = [
      t("srr.VIN"),
      t("srr.model"),
      t("srr.price"),
      t("srr.goldenIdFIO"),
      t("srr.goldenIdPosition"),
      t("srr.dataSales"),
    ];
    const thirdRow = [
      t("srr.DealerName"),
      t("srr.city"),
      t("srr.INN"),
      t("srr.uniqueCode"),
      t("srr.subject1"),
      t("srr.fo"),
      t("srr.activeDealers"),
    ];

    const secondRow = [
      ...[...Array(thirdRow.length).fill("")],
      ...tableRows[indexTable].soldCars
        .map(() => [
          {
            name: "",
            colSpan: 1,
          },
          {
            name: "",
            colSpan: 1,
          },
          {
            name: "",
            colSpan: 1,
          },
          {
            name: secondRowCellsForGenerate[0],
            colSpan: 2,
          },
          {
            name: "",
            colSpan: 1,
          },
        ])
        .flat(),
    ];

    const firstRow = [
      ...[...Array(thirdRow.length).fill("")],
      ...tableRows[indexTable].soldCars.map((el, index) => ({
        name:
          index === 0
            ? "Новые автомобили"
            : `Предыдущий автомобиль ${index} (по хронологии в обратном порядке)`,
        colSpan: thirdRowcellsForGenerate.length,
      })),
    ];

    return [
      firstRow,
      secondRow,
      [
        ...thirdRow,
        ...tableRows[indexTable].soldCars
          .map((el) => thirdRowcellsForGenerate.map((el) => el))
          .flat(),
      ],
    ];
  }
  return null;
};

export const customHeaderByWarmClients = (valueReport, tableRows, t) => {
  if (valueReport === "ReportNSByWarmClients" && tableRows.length > 0) {
    const thirdRowcellsForGenerate = [
      t("srr.VIN"),
      t("srr.FIOClient"),
      t("srr.goldenId"),
      t("srr.contact"),
      t("srr.email"),
      t("srr.dataSales"),
      t("srr.dataCredit"),
      t("srr.dataEndCredit"),
      t("srr.warrantyEndDate"),
      t("srr.ePlatformDate"),
    ];
    const thirdRow = [
      t("srr.DealerName"),
      t("srr.city"),
      t("srr.INN"),
      t("srr.filial"),
      t("srr.uniqueCode"),
      t("srr.subject1"),
      t("srr.fo"),
      t("srr.activeDealers"),
    ];

    const secondRow = [
      ...[...Array(thirdRow.length).fill("")],
      ...[
        {
          name: t("srr.1quarte"),
          colSpan: 10,
        },
      ],
    ];

    return [secondRow, [...thirdRow, ...thirdRowcellsForGenerate]];
  }
  return null;
};
const makeCustomHeaderStaticRow =
  (keys: string[], fieldKeys: string[]) => (valueReport, tableRows, t) => {
    if (keys.includes(valueReport) && tableRows.length > 0) {
      return [fieldKeys.map((el) => t(`srr.${el}`))];
    }
    return null;
  };

export const customHeaderByOldClients = makeCustomHeaderStaticRow(
  ["ReportNSByOldClients"],
  [
    "DealerName",
    "city",
    "INN",
    "filial",
    "uniqueCode",
    "subject1",
    "fo",
    "activeDealers",
    "carsTotalNS",
    "carModel",
    "Variant",
    "eqNumberNS",
    "vin",
    "sellDate",
    "ownershipPeriod",
    "ownerChangeDate",
    "carSaleDate",
    "newCarDate",
  ],
);

export const customHeaderByAverageCarAge = makeCustomHeaderStaticRow(
  ["ReportNSByAverageCarAge"],
  [
    "FIOClient",
    "vin",
    "mkv",
    "carPurchaseDate",
    "dataTO1",
    "dataTO2",
    "dataTO3",
    "dataTO4",
    "dataTO5",
    "mileageNS",
    "ownerChange",
    "ownershipPeriodByChange",
    "carPresumedSaleDate",
    "ownershipPeriodByEPlatform",
  ],
);

export const customHeaderByAverageCarAgeItog = (valueReport, t) => {
  if (valueReport === "ReportNSByAverageCarAgeItog") {
    const thirdRow = [
      t("srr.ownershipPeriodFrom"),
      t("srr.carsTotal"),
      t("srr.ownershipPeriodFrom"),
      t("srr.carsTotal"),
      t("srr.ownershipPeriodTo"),
    ];

    const secondRow = [
      {
        name: t("srr.itog"),
        colSpan: 5,
      },
    ];

    return [secondRow, thirdRow];
  }
  return null;
};

export const customHeaderByClientCarSale = (valueReport, tableRows, t) => {
  if (valueReport === "ReportNSByClientCarSale" && tableRows.length > 0) {
    const thirdRow = [
      t("srr.DealerName"),
      t("srr.city"),
      t("srr.INN"),
      t("srr.filial"),
      t("srr.uniqueCode"),
      t("srr.subject1"),
      t("srr.fo"),
      t("srr.activeDealers"),
      t("srr.carsOnEPlatform"),
      t("srr.clientsLada"),
      t("srr.percentCarsOnEPlatform"),
    ];

    const secondRow = [
      {
        name: "",
        colSpan: 8,
      },
      {
        name: t("srr.userChanges"),
        colSpan: 3,
      },
    ];
    return [secondRow, thirdRow];
  }
  return null;
};

const makeCustomHeaderByTO =
  (keys: string[], arrKey: "arrTO" | "arrGO", fixedPrefixKeys?: string[]) =>
  (valueReport, tableRows, t, groupSrr) => {
    if (keys.includes(valueReport) && tableRows.length > 0) {
      const prefixKeys = fixedPrefixKeys || groupProverka(groupSrr);
      const thirdRow = [
        ...prefixKeys.map((el) => t(`srr.${el}`)),
        ...(groupSrr[arrKey] || [])
          .map(() => [
            {
              name: t("srr.Sale"),
              colSpan: 1,
            },
            {
              name: t("srr.serviceCount"),
              colSpan: 1,
            },
            {
              name: t("srr.percent"),
              colSpan: 1,
            },
          ])
          .flat(),
      ];

      const secondRow = [
        {
          name: "",
          colSpan: prefixKeys.length,
        },

        ...(groupSrr[arrKey] || []).map((el) => ({
          name: t(`srr.${el}`),
          colSpan: 3,
        })),
      ];
      return [secondRow, thirdRow];
    }
    return null;
  };

export const customHeaderByTOMonthOfControlMine = makeCustomHeaderByTO(
  ["TOMonthOfControlMine"],
  "arrTO",
);

export const customHeaderByTOOwnBySalesPeriod = makeCustomHeaderByTO(
  ["TOOwnBySalesPeriod"],
  "arrTO",
);

export const customHeaderByWarrantyRepairMonthOfControl = makeCustomHeaderByTO(
  ["warrantyRepairMonthOfControl"],
  "arrGO",
);

const makeCustomHeaderByTOFriendOrFoe =
  (
    keys: string[],
    arrKey: "arrTO" | "arrGO",
    additionFields?: ICustomAdditionFields,
  ) =>
  (valueReport, tableRows, t, groupSrr) => {
    if (keys.includes(valueReport) && tableRows.length > 0) {
      const childOptions = groupProverka(groupSrr, additionFields);
      const thirdRow = [
        ...childOptions.map((el) => t(`srr.${el}`)),
        ...(groupSrr[arrKey] || [])
          .map(() => [
            {
              name: t("srr.Sale"),
              colSpan: 1,
            },
            {
              name: t("srr.serviceCountGeneral"),
              colSpan: 1,
            },
            {
              name: t("srr.percentGeneral"),
              colSpan: 1,
            },
            {
              name: t("srr.serviceCountMine"),
              colSpan: 1,
            },
            {
              name: t("srr.percentMine"),
              colSpan: 1,
            },
            {
              name: t("srr.serviceCountStranger"),
              colSpan: 1,
            },
            {
              name: t("srr.percentStranger"),
              colSpan: 1,
            },
          ])
          .flat(),
      ];

      const secondRow = [
        {
          name: "",
          colSpan: childOptions.length,
        },

        ...(groupSrr[arrKey] || []).map((el) => ({
          name: t(`srr.${el}`),
          colSpan: 7,
        })),
      ];

      return [secondRow, thirdRow];
    }
    return null;
  };

const FAMILY_ADDITION_FIELDS: ICustomAdditionFields = {
  dealerFields: ["family"],
  cityFields: ["family"],
  foFields: ["family"],
  regionFields: ["family"],
  countryFields: ["family"],
};

export const customHeaderByTOMonthOfControlFriendOrFoe =
  makeCustomHeaderByTOFriendOrFoe(["TOMonthOfControlFriendOrFoe"], "arrTO");

export const customHeaderByTOMonthOfControlFriendOrFoeByCarFamily =
  makeCustomHeaderByTOFriendOrFoe(
    ["TOMonthOfControlFriendOrFoeByCarFamily"],
    "arrTO",
    FAMILY_ADDITION_FIELDS,
  );

export const customHeaderByTOFriendOrFoeBySalesPeriod =
  makeCustomHeaderByTOFriendOrFoe(["TOFriendOrFoeBySalesPeriod"], "arrTO");

export const customHeaderByTOFriendOrFoeByPeriodByCarFamily =
  makeCustomHeaderByTOFriendOrFoe(
    ["TOFriendOrFoeByPeriodByCarFamily"],
    "arrTO",
    FAMILY_ADDITION_FIELDS,
  );

export const customHeaderByWarrantyRepairBySalesPeriod =
  makeCustomHeaderByTOFriendOrFoe(["warrantyRepairBySalesPeriod"], "arrGO");

export const customHeaderByTOMonthOfControlCarFamilyRegion =
  makeCustomHeaderByTO(["TOMonthOfControlCarFamilyRegion"], "arrTO", [
    "modelName",
  ]);

export const customHeaderByReportReturnCarServiceByDealer = (
  valueReport,
  tableRows,
  t,
  groupSrr,
) => {
  if (
    valueReport === "ReportReturnCarServiceByDealer" &&
    tableRows.length > 0
  ) {
    const periods = tableRows[0]?.periods?.map((el) => el.period) || [];

    const thirdRow = [
      ...groupProverka(groupSrr).map((el) => t(`srr.${el}`)),
      ...periods
        .map(() => [
          ...(groupSrr["arrTO"] || []).map((el) => ({
            name: t(`srr.${el}`),
            colSpan: 1,
          })),
          {
            name: t("srr.AllTO"),
            colSpan: 1,
          },
          {
            name: t("srr.Warranty"),
            colSpan: 1,
          },
          {
            name: t("srr.writ"),
            colSpan: 1,
          },
        ])
        .flat(),
    ];

    const secondRow = [
      {
        name: "",
        colSpan: groupProverka(groupSrr).length,
      },

      ...periods
        .map((el) => [
          {
            name: el,
            colSpan: (groupSrr["arrTO"] || []).length + 3,
          },
        ])
        .flat(),
    ];

    return [secondRow, thirdRow];
  }
  return null;
};

export const customHeaderByReportReturnSRR3ForPayments = (
  valueReport,
  tableRows,
  t,
  groupSrr,
) => {
  if (
    (valueReport === "ReportReturnSRR3ForPayments" ||
      valueReport === "ReportReturnSRR5ForPayments") &&
    tableRows.length > 0
  ) {
    const periods = tableRows[0]?.periods?.map((el) => el.period) || [];
    periods.push(`${periods[0]} - ${periods[periods.length - 1]}`);

    const logdaun = [
      "DealerName",
      "INN",
      "ent_id",
      "subject",
      "FO",
      "city",
    ].map((el) => t(`srr.${el}`));

    const thirdRow = [
      ...logdaun,
      ...periods
        .map(() => [
          {
            name: t("srr.target"),
            colSpan: 1,
          },
          {
            name: t("srr.countSale"),
            colSpan: 1,
          },
          {
            name: t("srr.countService"),
            colSpan: 1,
          },
          {
            name: t("srr.percent"),
            colSpan: 1,
          },
          {
            name: t("srr.percentTarget"),
            colSpan: 1,
          },
        ])
        .flat(),
    ];

    const secondRow = [
      {
        name: "",
        colSpan: 6,
      },

      ...periods
        .map((el) => [
          {
            name: el,
            colSpan: 5,
          },
        ])
        .flat(),
    ];

    return [secondRow, thirdRow];
  }
  return null;
};

export const customHeaderByReportReturnSRR3ByCar = (
  valueReport,
  tableRows,
  t,
  groupSrr,
) => {
  if (
    (valueReport === "ReportReturnSRR3ByCar" ||
      valueReport === "ReportReturnSRR5ByCar") &&
    tableRows.length > 0
  ) {
    const periods = tableRows[0]?.periods?.map((el) => el.period) || [];

    const hasTO4 = tableRows.some((row) =>
      row.periods.some((period) => period.TO4),
    );
    const hasTO5 = tableRows.some((row) =>
      row.periods.some((period) => period.TO5),
    );

    const periodsWithTO = periods.flatMap((period) => {
      const toColumns = [
        `ТО1 - ${period}`,
        `ТО2 - ${period}`,
        `ТО3 - ${period}`,
      ];
      if (hasTO4) toColumns.push(`ТО4 - ${period}`);
      if (hasTO5) toColumns.push(`ТО5 - ${period}`);
      return toColumns;
    });

    if (periods.length > 0) {
      const combinedPeriod = `${periods[0]} - ${periods[periods.length - 1]}`;
      periodsWithTO.push(combinedPeriod);
    }

    const logdaun = [
      "DealerName",
      "INN",
      "ent_id",
      "subject",
      "FO",
      "city",
      "family",
    ].map((el) => t(`srr.${el}`));

    const thirdRow = [
      ...logdaun,
      ...periodsWithTO
        .map(() => [
          {
            name: t("srr.countSale"),
            colSpan: 1,
          },
          {
            name: t("srr.countService"),
            colSpan: 1,
          },
          {
            name: t("srr.percent"),
            colSpan: 1,
          },
        ])
        .flat(),
    ];

    const secondRow = [
      {
        name: "",
        colSpan: 7,
      },
      ...periodsWithTO
        .map((el) => [
          {
            name: el,
            colSpan: 3,
          },
        ])
        .flat(),
    ];
    return [secondRow, thirdRow];
  }
  return null;
};

const makeCustomHeaderBySRRByDealer =
  (keys: string[]) => (valueReport, tableRows, t, groupSrr, groupTO) => {
    if (keys.includes(valueReport) && tableRows.length > 0) {
      const logdaun = [
        "DealerName",
        "INN",
        "ent_id",
        "subject",
        "FO",
        "city",
      ].map((el) => t(`srr.${el}`));

      const sk = groupTO
        .map(() => [
          {
            name: t("srr.Sale"),
            colSpan: 1,
          },
          {
            name: t("srr.serviceCount"),
            colSpan: 1,
          },
          {
            name: t("srr.percent"),
            colSpan: 1,
          },
        ])
        .flat();
      const thirdRow = [...logdaun, ...sk.flat()];

      const secondRow = [
        {
          name: "",
          colSpan: 6,
        },

        ...groupTO.map((el) => {
          if (el === "monthControl") {
            return {
              name: groupSrr["monthControl"],
              colSpan: 3,
            };
          } else {
            return {
              name: t(`srr.${el}`),
              colSpan: 3,
            };
          }
        }),
      ];

      return [secondRow, thirdRow];
    }
    return null;
  };

export const customHeaderByReportReturnSRR3ByDealer =
  makeCustomHeaderBySRRByDealer(["ReportReturnSRR3ByDealer"]);

export const customHeaderByReportReturnSRR5ByDealer =
  makeCustomHeaderBySRRByDealer(["ReportReturnSRR5ByDealer"]);

export const getCustomTableBody = (type: string) => {
  switch (type) {
    case "ReportReturnUniqueService":
      return ReportReturnUniqueServiceTable;
    case "ReportReturnLoyaltyServiceByDealer":
      return ReportReturnLoyaltyServiceByDealerTable;
    case "ReportNSByDealer":
      return ReportNSByDealer;
    case "ReportNSByConsultant":
      return ReportNSByConsultant;
    case "ReportNSByClient":
      return ReportNSByClient;
    case "ReportNSByWarmClients":
      return ReportNSByWarmClients;
    case "ReportNSByAverageCarAge":
      return ReportNSByAverageCarAge;
    case "ReportNSByAverageCarAgeItog":
      return ReportNSByAverageCarAgeItog;
    case "ReportNSByOldClients":
      return ReportNSByOldClients;
    case "ReportNSByClientCarSale":
      return ReportNSByClientCarSale;
    case "TOMonthOfControlMine":
      return TOMonthOfControlMine;
    case "TOOwnBySalesPeriod":
      return TOOwnBySalesPeriod;
    case "warrantyRepairMonthOfControl":
      return warrantyRepairMonthOfControl;
    case "TOMonthOfControlFriendOrFoe":
      return TOMonthOfControlFriendOrFoe;
    case "TOMonthOfControlFriendOrFoeByCarFamily":
      return TOMonthOfControlFriendOrFoeByCarFamily;
    case "TOFriendOrFoeBySalesPeriod":
      return TOFriendOrFoeBySalesPeriod;
    case "TOFriendOrFoeByPeriodByCarFamily":
      return TOFriendOrFoeByPeriodByCarFamily;
    case "warrantyRepairBySalesPeriod":
      return warrantyRepairBySalesPeriod;
    case "TOMonthOfControlCarFamilyRegion":
      return TOMonthOfControlCarFamilyRegion;
    case "TOReturnCarForServiceByPeriodConsolidated":
      return TOReturnCarForServiceByPeriodConsolidated;
    case "ReportReturnCarServiceByDealer":
      return ReportReturnCarServiceByDealer;
    case "ReportReturnSRR3ForPayments":
      return ReportReturnSRR3ForPayments;
    case "ReportReturnSRR5ForPayments":
      return ReportReturnSRR3ForPayments;
    case "ReportReturnSRR3ByCar":
      return ReportReturnSRR3ByCar;
    case "ReportReturnSRR5ByCar":
      return ReportReturnSRR3ByCar;
    case "ReportReturnSRR3ByDealer":
      return ReportReturnSRR3ByDealer;
    case "ReportReturnSRR5ByDealer":
      return ReportReturnSRR5ByDealer;
    default:
      return undefined;
  }
};
